import React from "react";
import {
  HiOutlineShoppingBag,
  HiOutlineBriefcase,
  HiOutlineCalendar,
  HiOutlineOfficeBuilding,
  HiOutlineIdentification,
  HiOutlineDeviceMobile,
  HiOutlineGift,
  HiOutlineClipboardList,
  HiOutlineStar,
  HiOutlinePencilAlt,
  HiOutlineQrcode,
  HiOutlineTicket,
  HiOutlineUserAdd,
} from "react-icons/hi";
import { MdOutlineRestaurant } from "react-icons/md";

export type VerticalSlug =
  | "retail"
  | "restaurants"
  | "services"
  | "events"
  | "b2b";

export type PlanBadge = "free";

export interface VerticalSuggestion {
  key: string;
  icon: React.ComponentType<any>;
  route: string;
  badge?: PlanBadge;
}

export type PreviewKind = "loyalty" | "card" | "events";

export interface VerticalDef {
  slug: VerticalSlug;
  icon: React.ComponentType<any>;
  preview: PreviewKind;
  suggestions: VerticalSuggestion[];
}

export const PREVIEW_IMAGES: Record<PreviewKind, { fr: string; en: string }> = {
  card: {
    fr: "https://cdn.1cdn.app/application/UMD/26071311243898_sample_business_card.png",
    en: "https://cdn.1cdn.app/application/UMD/26071311243898_sample_business_card.png",
  },
  loyalty: {
    fr: "https://cdn.1cdn.app/application/UMD/26071322164877_loyalty_card.png",
    en: "https://cdn.1cdn.app/application/UMD/26071322164877_loyalty_card.png",
  },
  events: {
    fr: "https://cdn.1cdn.app/application/UMD/26071311302354_festival_partner.png",
    en: "https://cdn.1cdn.app/application/UMD/26071311302354_festival_partner.png",
  },
};

export const getPreviewImageSrc = (
  kind: PreviewKind,
  language: string
): string => {
  const entry = PREVIEW_IMAGES[kind];
  const lang = language?.toLowerCase().startsWith("fr") ? "fr" : "en";
  return entry[lang] || entry.en || "";
};

export const VERTICALS: VerticalDef[] = [
  {
    slug: "retail",
    icon: HiOutlineShoppingBag,
    preview: "loyalty",
    suggestions: [
      {
        key: "loyalty",
        icon: HiOutlineGift,
        route: "/control-panel/lmc",
        badge: "free",
      },
      {
        key: "customerFile",
        icon: HiOutlineUserAdd,
        route: "/control-panel/signup-forms",
        badge: "free",
      },
      {
        key: "walletCard",
        icon: HiOutlineDeviceMobile,
        route: "/control-panel/lmc",
      },
    ],
  },
  {
    slug: "restaurants",
    icon: MdOutlineRestaurant,
    preview: "loyalty",
    suggestions: [
      {
        key: "loyalty",
        icon: HiOutlineGift,
        route: "/control-panel/lmc",
        badge: "free",
      },
      {
        key: "googleReviews",
        icon: HiOutlineStar,
        route: "/control-panel/lmc",
      },
      {
        key: "walletCard",
        icon: HiOutlineDeviceMobile,
        route: "/control-panel/lmc",
      },
    ],
  },
  {
    slug: "services",
    icon: HiOutlineBriefcase,
    preview: "card",
    suggestions: [
      {
        key: "prospects",
        icon: HiOutlineClipboardList,
        route: "/control-panel/signup-forms",
        badge: "free",
      },
      {
        key: "esign",
        icon: HiOutlinePencilAlt,
        route: "/control-panel/e-signature",
      },
      {
        key: "card",
        icon: HiOutlineIdentification,
        route: "/control-panel/business-card",
        badge: "free",
      },
      {
        key: "loyalty",
        icon: HiOutlineGift,
        route: "/control-panel/lmc",
        badge: "free",
      },
    ],
  },
  {
    slug: "events",
    icon: HiOutlineCalendar,
    preview: "events",
    suggestions: [
      {
        key: "registrations",
        icon: HiOutlineUserAdd,
        route: "/control-panel/event-payments",
      },
      {
        key: "ticketing",
        icon: HiOutlineTicket,
        route: "/control-panel/event-payments",
      },
      {
        key: "staffApp",
        icon: HiOutlineQrcode,
        route: "/control-panel/event-payments",
      },
    ],
  },
  {
    slug: "b2b",
    icon: HiOutlineOfficeBuilding,
    preview: "card",
    suggestions: [
      {
        key: "teamCards",
        icon: HiOutlineIdentification,
        route: "/control-panel/business-card",
        badge: "free",
      },
      {
        key: "leads",
        icon: HiOutlineClipboardList,
        route: "/control-panel/leads",
        badge: "free",
      },
      {
        key: "esign",
        icon: HiOutlinePencilAlt,
        route: "/control-panel/e-signature",
      },
    ],
  },
];
